function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  max-width: 40rem; /* Reference와 동일: max-w-4xl */\n  margin-left: auto;\n  margin-right: auto;\n  padding: 1.5rem 1rem; /* Reference와 동일: py-6 px-4 */\n  min-height: 100vh;\n  background-color: ",
        "; /* 테마 배경색 적용 */\n\n  @media (min-width: ",
        ") {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: 2rem;\n  width: 2rem;\n  animation: spin 1s linear infinite;\n  color: var(--theme-primary, #3b82f6);\n\n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--theme-error, #dc2626);\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text-secondary, #4b5563);\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  gap: 1rem;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  color: var(--theme-text-secondary);\n  font-weight: 500;\n  border-radius: 0.375rem;\n  padding: 0.5rem;\n  \n  &:hover {\n    background-color: var(--theme-paper-hover);\n    color: var(--theme-text);\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: var(--theme-text, #1f2937);\n  margin: 0;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.5rem;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  margin-top: 4rem; /* Reference와 동일: mt-16 -> 4rem */\n  > * + * {\n    margin-top: 1.5rem; /* Reference와 동일: space-y-6 */\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid ",
        ";\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  background: ",
        ";\n  color: ",
        ";\n  transition: all 0.2s ease-in-out;\n  \n  &:focus {\n    outline: none;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 3px ",
        "; /* 10% opacity */\n  }\n  \n  &:disabled {\n    background-color: ",
        ";\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid ",
        ";\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  background: ",
        ";\n  color: ",
        ";\n  transition: all 0.2s ease-in-out;\n  resize: vertical;\n  min-height: 100px;\n  \n  &:focus {\n    outline: none;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 3px ",
        "; /* 10% opacity */\n  }\n  \n  &:disabled {\n    background-color: ",
        ";\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 0.875rem;\n  padding: 0.75rem;\n  background: ",
        ";\n  border-radius: 0.375rem;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  height: 1rem;\n  width: 1rem;\n  animation: spin 1s linear infinite;\n  margin-right: 0.5rem;\n\n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import React, { useState, useEffect } from 'react';
import { Loader2, Save, X, ArrowLeft } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import ProfileBanner from '../ProfileBanner/ProfileBanner';
import { profileEdit_title, profileEdit_fields_displayName, profileEdit_fields_username, profileEdit_fields_bio, profileEdit_fields_location, profileEdit_fields_website, profileEdit_placeholders_displayName, profileEdit_placeholders_username, profileEdit_placeholders_bio, profileEdit_placeholders_location, profileEdit_placeholders_website, profileEdit_buttons_save, profileEdit_buttons_saving, profileEdit_buttons_cancel } from '@paraglide/messages';
import { useToast } from './useToast';
import { PROFILE_EDIT_TEST_IDS } from '@edusense/shared-constants';
// Reference와 동일한 Container 레이아웃 + 테마 배경색
var ProfileEditContainer = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.sm;
});
// Reference와 동일한 로딩 컨테이너
var LoadingContainer = styled.div(_templateObject1());
var LoadingSpinner = styled(Loader2)(_templateObject2());
// Reference와 동일한 에러 컨테이너
var ErrorContainer = styled.div(_templateObject3());
var ErrorTitle = styled.h2(_templateObject4());
var ErrorMessageText = styled.p(_templateObject5());
// Reference와 동일한 페이지 헤더
var PageHeader = styled.div(_templateObject6());
var BackButton = styled.button(_templateObject7());
var PageTitle = styled.h1(_templateObject8());
// Reference와 동일한 컨텐츠 래퍼
var ContentWrapper = styled.div(_templateObject9());
// Reference와 동일한 프로필 폼
var ProfileForm = styled.form(_templateObject10());
// Reference와 동일한 Input 스타일링
var InputField = styled.div(_templateObject11());
var Label = styled.label(_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.text;
});
var Input = styled.input(_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.border;
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.text;
}, function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.primary, "1a");
}, function(param) {
    var theme = param.theme;
    return theme.paperLight;
});
var Textarea = styled.textarea(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.border;
}, function(param) {
    var theme = param.theme;
    return theme.background;
}, function(param) {
    var theme = param.theme;
    return theme.text;
}, function(param) {
    var theme = param.theme;
    return theme.primary;
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.primary, "1a");
}, function(param) {
    var theme = param.theme;
    return theme.paperLight;
});
// Reference와 동일한 에러 표시
var FormError = styled.div(_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.error;
}, function(param) {
    var theme = param.theme;
    return theme.errorBg || '#fef2f2';
}, function(param) {
    var theme = param.theme;
    return theme.error;
});
// Reference와 동일한 버튼 컨테이너
var ButtonContainer = styled.div(_templateObject16());
var SavingSpinner = styled(Loader2)(_templateObject17());
/**
 * Reference UI를 그대로 재현한 ProfileEdit 컴포넌트
 */ var ProfileEdit = function(param) {
    var user = param.user, onSave = param.onSave, onCancel = param.onCancel, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading;
    var _user_basicInfo, _user_basicInfo1, _user_basicInfo2, _user_profileInfo, _user_profileInfo1, _user_profileInfo2, _user_profileInfo3, _formData_basicInfo, _formData_profileInfo, _formData_basicInfo1, _formData_basicInfo2, _formData_basicInfo3, _formData_profileInfo1, _formData_profileInfo2, _formData_profileInfo3;
    // Reference와 동일한 상태 관리
    var _useState = _sliced_to_array(useState({
        basicInfo: {
            displayName: (user === null || user === void 0 ? void 0 : (_user_basicInfo = user.basicInfo) === null || _user_basicInfo === void 0 ? void 0 : _user_basicInfo.displayName) || (user === null || user === void 0 ? void 0 : user.name) || '',
            profileImageUrl: (user === null || user === void 0 ? void 0 : (_user_basicInfo1 = user.basicInfo) === null || _user_basicInfo1 === void 0 ? void 0 : _user_basicInfo1.profileImageUrl) || (user === null || user === void 0 ? void 0 : user.profileImage) || '',
            username: (user === null || user === void 0 ? void 0 : (_user_basicInfo2 = user.basicInfo) === null || _user_basicInfo2 === void 0 ? void 0 : _user_basicInfo2.username) || (user === null || user === void 0 ? void 0 : user.username) || ''
        },
        profileInfo: {
            bio: (user === null || user === void 0 ? void 0 : (_user_profileInfo = user.profileInfo) === null || _user_profileInfo === void 0 ? void 0 : _user_profileInfo.bio) || '',
            location: (user === null || user === void 0 ? void 0 : (_user_profileInfo1 = user.profileInfo) === null || _user_profileInfo1 === void 0 ? void 0 : _user_profileInfo1.location) || '',
            website: (user === null || user === void 0 ? void 0 : (_user_profileInfo2 = user.profileInfo) === null || _user_profileInfo2 === void 0 ? void 0 : _user_profileInfo2.website) || '',
            coverImageUrl: (user === null || user === void 0 ? void 0 : (_user_profileInfo3 = user.profileInfo) === null || _user_profileInfo3 === void 0 ? void 0 : _user_profileInfo3.coverImageUrl) || ''
        }
    }), 2), formData = _useState[0], setFormData = _useState[1];
    // Reference와 동일한 이미지 상태
    var _useState1 = _sliced_to_array(useState({
        file: null,
        tempUrl: ''
    }), 2), profileImageState = _useState1[0], setProfileImageState = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        file: null,
        tempUrl: ''
    }), 2), coverImageState = _useState2[0], setCoverImageState = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isSaving = _useState3[0], setIsSaving = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), error = _useState4[0], setError = _useState4[1];
    var toast = useToast().toast;
    // user 데이터가 처음 로드될 때만 formData 초기화하여, 저장 직후 입력값이 되돌아가는 문제 방지
    var _useState5 = _sliced_to_array(useState(false), 2), initializedFromUser = _useState5[0], setInitializedFromUser = _useState5[1];
    useEffect(function() {
        if (user && !initializedFromUser) {
            var _user_basicInfo, _user_basicInfo1, _user_basicInfo2, _user_profileInfo, _user_profileInfo1, _user_profileInfo2, _user_profileInfo3;
            var newFormData = {
                basicInfo: {
                    displayName: ((_user_basicInfo = user.basicInfo) === null || _user_basicInfo === void 0 ? void 0 : _user_basicInfo.displayName) || user.name || '',
                    profileImageUrl: ((_user_basicInfo1 = user.basicInfo) === null || _user_basicInfo1 === void 0 ? void 0 : _user_basicInfo1.profileImageUrl) || user.profileImage || '',
                    username: ((_user_basicInfo2 = user.basicInfo) === null || _user_basicInfo2 === void 0 ? void 0 : _user_basicInfo2.username) || user.username || ''
                },
                profileInfo: {
                    bio: ((_user_profileInfo = user.profileInfo) === null || _user_profileInfo === void 0 ? void 0 : _user_profileInfo.bio) || '',
                    location: ((_user_profileInfo1 = user.profileInfo) === null || _user_profileInfo1 === void 0 ? void 0 : _user_profileInfo1.location) || '',
                    website: ((_user_profileInfo2 = user.profileInfo) === null || _user_profileInfo2 === void 0 ? void 0 : _user_profileInfo2.website) || '',
                    coverImageUrl: ((_user_profileInfo3 = user.profileInfo) === null || _user_profileInfo3 === void 0 ? void 0 : _user_profileInfo3.coverImageUrl) || ''
                }
            };
            setFormData(newFormData);
            setInitializedFromUser(true);
        }
    }, [
        user,
        initializedFromUser
    ]);
    // Reference와 동일한 이미지 최적화
    var optimizeImage = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(file) {
            var maxWidth, maxHeight;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                maxWidth = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 1200, maxHeight = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1200;
                return [
                    2,
                    new Promise(function(resolve) {
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');
                        var img = new Image();
                        img.onload = function() {
                            var width = img.width, height = img.height;
                            if (width > height) {
                                if (width > maxWidth) {
                                    height = height * maxWidth / width;
                                    width = maxWidth;
                                }
                            } else {
                                if (height > maxHeight) {
                                    width = width * maxHeight / height;
                                    height = maxHeight;
                                }
                            }
                            canvas.width = width;
                            canvas.height = height;
                            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, width, height);
                            canvas.toBlob(function(blob) {
                                if (blob) {
                                    var optimizedFile = new File([
                                        blob
                                    ], file.name, {
                                        type: file.type,
                                        lastModified: Date.now()
                                    });
                                    resolve(optimizedFile);
                                } else {
                                    resolve(file);
                                }
                            }, file.type, 0.8);
                        };
                        img.src = URL.createObjectURL(file);
                    })
                ];
            });
        });
        return function optimizeImage(file) {
            return _ref.apply(this, arguments);
        };
    }();
    // Reference와 동일한 이미지 핸들러
    var handleProfileImageSelect = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(file) {
            var optimizedFile, tempUrl, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            optimizeImage(file)
                        ];
                    case 1:
                        optimizedFile = _state.sent();
                        tempUrl = URL.createObjectURL(optimizedFile);
                        setProfileImageState({
                            file: optimizedFile,
                            tempUrl: tempUrl
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error('프로필 이미지 처리 오류:', error);
                        toast.error('이미지 처리 중 오류가 발생했습니다.');
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleProfileImageSelect(file) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCoverImageSelect = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(file) {
            var optimizedFile, tempUrl, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            optimizeImage(file, 1500, 500)
                        ];
                    case 1:
                        optimizedFile = _state.sent();
                        tempUrl = URL.createObjectURL(optimizedFile);
                        setCoverImageState({
                            file: optimizedFile,
                            tempUrl: tempUrl
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error('커버 이미지 처리 오류:', error);
                        toast.error('이미지 처리 중 오류가 발생했습니다.');
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCoverImageSelect(file) {
            return _ref.apply(this, arguments);
        };
    }();
    // Reference와 동일한 입력 핸들러
    var handleInputChange = function(e) {
        var _e_target = e.target, name = _e_target.name, value = _e_target.value;
        setFormData(function(prev) {
            if (name === 'displayName' || name === 'username') {
                return _object_spread_props(_object_spread({}, prev), {
                    basicInfo: _object_spread_props(_object_spread({}, prev.basicInfo), _define_property({}, name, value))
                });
            } else if ([
                'bio',
                'location',
                'website'
            ].includes(name)) {
                return _object_spread_props(_object_spread({}, prev), {
                    profileInfo: _object_spread_props(_object_spread({}, prev.profileInfo), _define_property({}, name, value))
                });
            }
            return prev;
        });
    };
    // Reference와 동일한 저장 핸들러
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var error, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!formData) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsSaving(true);
                        setError(null);
                        return [
                            4,
                            onSave(formData, profileImageState.file || undefined, coverImageState.file || undefined)
                        ];
                    case 2:
                        _state.sent();
                        setProfileImageState({
                            file: null,
                            tempUrl: ''
                        });
                        setCoverImageState({
                            file: null,
                            tempUrl: ''
                        });
                        toast.success('프로필이 성공적으로 업데이트되었습니다.');
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        errorMessage = '프로필을 업데이트하는 중 오류가 발생했습니다.';
                        setError(errorMessage);
                        toast.error(errorMessage);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSaving(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // 메모리 누수 방지
    useEffect(function() {
        return function() {
            if (profileImageState.tempUrl) {
                URL.revokeObjectURL(profileImageState.tempUrl);
            }
            if (coverImageState.tempUrl) {
                URL.revokeObjectURL(coverImageState.tempUrl);
            }
        };
    }, [
        profileImageState.tempUrl,
        coverImageState.tempUrl
    ]);
    // Reference와 동일한 이미지 URL 처리
    var getImageUrl = function(imageUrl) {
        var tempUrl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
        if (tempUrl) return tempUrl;
        if (!imageUrl) return '';
        if (imageUrl.startsWith('http') || imageUrl.startsWith('data:')) return imageUrl;
        return imageUrl;
    };
    var finalProfileImageUrl = getImageUrl(formData === null || formData === void 0 ? void 0 : (_formData_basicInfo = formData.basicInfo) === null || _formData_basicInfo === void 0 ? void 0 : _formData_basicInfo.profileImageUrl, profileImageState.tempUrl);
    var profileImageUrlForBanner = finalProfileImageUrl && !finalProfileImageUrl.includes('via.placeholder.com') ? finalProfileImageUrl : null;
    var finalCoverImageUrl = getImageUrl(formData === null || formData === void 0 ? void 0 : (_formData_profileInfo = formData.profileInfo) === null || _formData_profileInfo === void 0 ? void 0 : _formData_profileInfo.coverImageUrl, coverImageState.tempUrl);
    var coverImageUrlForBanner = finalCoverImageUrl && !finalCoverImageUrl.includes('via.placeholder.com') ? finalCoverImageUrl : null;
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoadingContainer, null, /*#__PURE__*/ React.createElement(LoadingSpinner, null));
    }
    if (!formData) {
        return /*#__PURE__*/ React.createElement(ErrorContainer, null, /*#__PURE__*/ React.createElement(ErrorTitle, null, "오류 발생"), /*#__PURE__*/ React.createElement(ErrorMessageText, null, "프로필 정보를 찾을 수 없습니다."));
    }
    // Reference와 동일한 UI 구조
    return /*#__PURE__*/ React.createElement(ProfileEditContainer, null, /*#__PURE__*/ React.createElement(PageHeader, null, onCancel && /*#__PURE__*/ React.createElement(BackButton, {
        onClick: onCancel,
        disabled: isSaving
    }, /*#__PURE__*/ React.createElement(ArrowLeft, {
        size: 20
    })), /*#__PURE__*/ React.createElement(PageTitle, {
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_TITLE
    }, profileEdit_title())), /*#__PURE__*/ React.createElement(ContentWrapper, null, /*#__PURE__*/ React.createElement(ProfileBanner, {
        profileImage: profileImageUrlForBanner,
        coverImage: coverImageUrlForBanner,
        username: (user === null || user === void 0 ? void 0 : user.username) || '',
        name: ((_formData_basicInfo1 = formData.basicInfo) === null || _formData_basicInfo1 === void 0 ? void 0 : _formData_basicInfo1.displayName) || '',
        isEditable: true,
        onProfileImageClick: handleProfileImageSelect,
        onCoverImageClick: handleCoverImageSelect
    }), /*#__PURE__*/ React.createElement(ProfileForm, {
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_FORM,
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(InputField, null, /*#__PURE__*/ React.createElement(Label, {
        htmlFor: "username"
    }, profileEdit_fields_username()), /*#__PURE__*/ React.createElement(Input, {
        id: "username",
        name: "username",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_USERNAME,
        value: ((_formData_basicInfo2 = formData.basicInfo) === null || _formData_basicInfo2 === void 0 ? void 0 : _formData_basicInfo2.username) || '',
        onChange: handleInputChange,
        placeholder: profileEdit_placeholders_username(),
        disabled: isSaving,
        required: true
    })), /*#__PURE__*/ React.createElement(InputField, null, /*#__PURE__*/ React.createElement(Label, {
        htmlFor: "displayName"
    }, profileEdit_fields_displayName()), /*#__PURE__*/ React.createElement(Input, {
        id: "displayName",
        name: "displayName",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_DISPLAY_NAME,
        value: ((_formData_basicInfo3 = formData.basicInfo) === null || _formData_basicInfo3 === void 0 ? void 0 : _formData_basicInfo3.displayName) || '',
        onChange: handleInputChange,
        placeholder: profileEdit_placeholders_displayName(),
        disabled: isSaving,
        required: true
    })), /*#__PURE__*/ React.createElement(InputField, null, /*#__PURE__*/ React.createElement(Label, {
        htmlFor: "bio"
    }, profileEdit_fields_bio()), /*#__PURE__*/ React.createElement(Textarea, {
        id: "bio",
        name: "bio",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_BIO,
        value: ((_formData_profileInfo1 = formData.profileInfo) === null || _formData_profileInfo1 === void 0 ? void 0 : _formData_profileInfo1.bio) || '',
        onChange: handleInputChange,
        placeholder: profileEdit_placeholders_bio(),
        disabled: isSaving
    })), /*#__PURE__*/ React.createElement(InputField, null, /*#__PURE__*/ React.createElement(Label, {
        htmlFor: "location"
    }, profileEdit_fields_location()), /*#__PURE__*/ React.createElement(Input, {
        id: "location",
        name: "location",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_LOCATION,
        value: ((_formData_profileInfo2 = formData.profileInfo) === null || _formData_profileInfo2 === void 0 ? void 0 : _formData_profileInfo2.location) || '',
        onChange: handleInputChange,
        placeholder: profileEdit_placeholders_location(),
        disabled: isSaving
    })), /*#__PURE__*/ React.createElement(InputField, null, /*#__PURE__*/ React.createElement(Label, {
        htmlFor: "website"
    }, profileEdit_fields_website()), /*#__PURE__*/ React.createElement(Input, {
        id: "website",
        name: "website",
        type: "url",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_WEBSITE,
        value: ((_formData_profileInfo3 = formData.profileInfo) === null || _formData_profileInfo3 === void 0 ? void 0 : _formData_profileInfo3.website) || '',
        onChange: handleInputChange,
        placeholder: profileEdit_placeholders_website(),
        disabled: isSaving
    })), error && /*#__PURE__*/ React.createElement(FormError, null, error), /*#__PURE__*/ React.createElement(ButtonContainer, null, onCancel && /*#__PURE__*/ React.createElement(Button, {
        type: "button",
        variant: "outline",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_CANCEL,
        onClick: onCancel,
        disabled: isSaving
    }, /*#__PURE__*/ React.createElement(X, {
        size: 16
    }), profileEdit_buttons_cancel()), /*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        variant: "primary",
        "data-testid": PROFILE_EDIT_TEST_IDS.PROFILE_EDIT_SUBMIT,
        disabled: isSaving
    }, isSaving ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SavingSpinner, null), profileEdit_buttons_saving()) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Save, {
        size: 16
    }), profileEdit_buttons_save()))))));
};
export default ProfileEdit;
